import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources - EN, ES, FR, IT
const resources = {
  en: {
    translation: {
      // Common
      "welcome": "",
      "admin": "Admin",
      "system_settings": "System Settings",
      "logout": "Logout",
      "login": "Login",
      "register": "Register",
      "loading": "Loading",
      "save": "Save",
      "cancel": "Cancel",
      "delete": "Delete",
      "edit": "Edit",
      "update": "Update",
      "create": "Create",
      "search": "Search",
      "filter": "Filter",
      "clear": "Clear",
      "refresh": "Refresh",
      "back": "Back",
      "close": "Close",
      "yes": "Yes",
      "no": "No",
      "all": "All",
      "please_wait": "Please wait...",
      
      // Login Page
      "username_email": "Username/Email",
      "password": "Password",
      "confirm_password": "Confirm Password",
      "first_name": "First Name",
      "last_name": "Last Name",
      "phone_number": "Phone Number",
      "country": "Country",
      "phone_number_placeholder": "Phone number",
      "email_placeholder": "your.email@example.com",
      "dont_have_account": "Don't have an account? Register",
      "already_have_account": "Already have an account? Login",
      "passwords_not_match": "Passwords do not match. Please try again.",
      "registration_successful": "Registration successful! Please login.",
      "pending_admin_approval": "Pending admin approval",
      "you_will_be_able_to_login": "You will be able to login once approved.",
      
      // Scanner Dashboard
      "scanner_dashboard": "Resistance Scanner",
      "view_toggle_label": "Quick Switch",
      "resistance_scanner_label": "Resistance Scanner",
      "earnings_label": "Earnings",
      "scanner_options": "Scanner Options",
      "run_scanner": "Run Scanner",
      "ib_trading": "IB Trading",
      "scanner": "Scanner",
      "select_all": "Select All",
      "clear_all": "Clear All",
      "saved_lists": "Saved Lists",
      "last_updated": "Last updated",
      "just_now": "Just now",
      "found_scan_results": "Found",
      "scan_results": "scan results",
      "no_scan_results": "No scan results found. Use the left menu to run a scan or adjust your filters.",
      
      // Table Headers
      "id": "ID",
      "symbol": "Symbol",
      "put_call": "Put/Call",
      "live_price": "Live Price",
      "entry": "Entry",
      "stop": "Stop",
      "target": "Target",
      "risk_reward": "R:R",
      "status": "Status",
      "scan_date": "Scan Date",
      "actions": "Actions",
      "signal": "Signal",
      "price": "Price",
      
      // Scanner Menu
      "symbols": "Symbols",
      "selected": "selected",
      "period": "Period",
      "interval": "Interval",
      "lookback_bars": "Lookback Bars",
      "account_size": "Account Size ($)",
      "risk_per_trade": "Risk Per Trade (%)",
      "save_current": "Save Current",
      "scanner_options": "Scanner Options",
      "run_scanner": "Run Scanner",
      "running_scan": "Running Scan...",
      "saved_lists_heading": "Your Saved Lists:",
      "symbol_count_label": "{{count}} symbols",
      "load_symbols_tooltip": "Load symbols",
      "run_saved_list_tooltip": "Run scan immediately",
      "delete_list_tooltip": "Delete list",
      "load": "Load",
      "run_now": "Run",
      "symbols_found_count": "{{count}} symbols found",
      "selected_count_label": "Selected ({{count}}):",
      "period_recommended_hint": "Recommended: 5 Days",
      "period_helper_text": "5 days provides optimal context for intraday breakouts",
      "interval_recommended_hint": "Recommended: 5 Min",
      "interval_helper_text": "5-minute is industry standard for day trading scans",
      "lookback_recommended_hint": "Recommended: 100",
      "lookback_helper_text": "50-100 bars ideal for recent breakout detection",
      "risk_pct_hint": "0.1-10%",
      "save_symbol_list_title": "Save Symbol List",
      "save_symbol_list_description": "Save your current selection of {{count}} symbols for quick access later.",
      "deselect_all": "Deselect all",
      "enter_list_name_alert": "Please enter a name for this symbol list.",
      "save_list_success": "✅ Saved \"{{name}}\" with {{count}} symbols",
      "save_list_failed": "Failed to save symbol list",
      "load_list_success": "✅ Loaded \"{{name}}\" ({{count}} symbols)",
      "delete_list_success": "✅ Deleted \"{{name}}\"",
      "delete_list_failed": "Failed to delete symbol list",
      "confirm_delete_list": "Delete \"{{name}}\"?",
      "run_saved_list_initiated": "✅ Running scan for \"{{name}}\"...",
      "select_all_success": "Selected {{count}} symbols",
      "scan_summary_with_signals": "✅ Scanned {{total}} symbols! Found {{signals}} total signal(s): {{summary}}",
      "scan_summary_no_signals": "✅ Scanned {{total}} symbols - No signals found",
      "scan_failed": "Scan failed",
      "how_it_works": "How it works:",
      "search_by_symbol": "Search by symbol or company name (comma-separated symbols supported, e.g. AAPL, MSFT or Apple)...",
      "no_symbols_found": "No symbols found",
      "symbols_found": "symbols found",
      "showing_first_100": "Showing first 100 results. Keep typing to narrow search...",
      "select_symbol": "Select a symbol from S&P 500",
      "configure_params": "Configure scan parameters",
      "click_run_scanner": "Click 'Run Scanner' to execute",
      "results_appear": "Results appear in the table",
      "click_rows": "Click rows for signal verification",
      "recommended": "Recommended",
      "save_symbol_list": "Save Symbol List",
      "enter_list_name": "Enter a name for this list...",
      "save_selection": "Save your current selection of",
      "symbols_quick_access": "symbols for quick access later.",
      
      // Filters
      "has_signal": "Has Signal",
      "pending": "Pending",
      "enter_now": "Enter Now",
      "target_hit": "Target Hit",
      "stopped": "Stopped",
      "expired": "Expired",
      "invalid": "Invalid",
      
      // Actions
      "remove": "Remove",
      "trade": "Trade",
      "verify": "Verify",
      "verify_all": "Verify All",
      "archive_expired": "Archive Expired",
      "refreshing": "Refreshing...",
      "are_you_sure_remove": "Are you sure you want to remove this scan result?",
      "verify_all_positions": "Verify all {{count}} positions in the table?",
      "archive_expired_positions": "Archive {{count}} expired position(s)? This will hide them from the active view.",
      "no_expired_found": "No expired positions found in the current view.",
      
      // Admin Panel
      "admin_panel": "Admin Panel",
      "user_management": "User Management Dashboard",
      "create_new_user": "Create New User",
      "total_users": "Total Users",
      "pending_approval": "Pending Approval",
      "active_users": "Active Users",
      "inactive_users": "Inactive Users",
      "admin_users": "Admin Users",
      "username": "Username",
      "role": "Role",
      "created_at": "Created At",
      "user": "User",
      "approve": "Approve",
      "disable": "Disable",
      "enable": "Enable",
      "change_password": "Change Password",
      "make_admin": "Make Admin",
      "remove_admin": "Remove Admin",
      "new_password": "New Password",
      "make_user_admin": "Make this user an admin",
      "user_created_successfully": "User created successfully",
      "user_updated_successfully": "User updated successfully",
      "user_deleted_successfully": "User deleted successfully",
      "are_you_sure_delete_user": "Are you sure you want to delete user",
      "create_user": "Create User",
      "change_password_for": "Change Password for",
      "no_users_found": "No users found",
      "active": "Active",
      "disabled": "Disabled",
      "pending": "Pending",
      
      // IB Trading
      "ib_credentials": "Credentials",
      "trading_dashboard": "Trading Dashboard",
      "interactive_brokers_setup": "Interactive Brokers Setup",
      "ib_credentials_configured": "IB Credentials Configured",
      "ib_username": "IB Username",
      "ib_password": "IB Password",
      "account_id": "Account ID",
      "password_encrypted": "••••••••••••• (encrypted)",
      "update_credentials": "Update Credentials",
      "delete_credentials": "Delete Credentials",
      "add_ib_credentials": "Add IB Credentials",
      "connect_ib_account": "Connect your Interactive Brokers paper trading account to enable automated options trading.",
      "ib_paper_account_id": "IB Paper Account ID",
      "default_paper_account": "Default: DUN146698 (paper trading account)",
      "save_credentials": "Save Credentials",
      "saving": "Saving...",
      "security_note": "Security Note:",
      "credentials_encrypted": "Your credentials are encrypted before storage using industry-standard encryption.",
      "ib_credentials_saved": "IB credentials saved successfully!",
      "ib_credentials_deleted": "IB credentials deleted successfully",
      "are_you_sure_delete_credentials": "Are you sure you want to delete your IB credentials?",
      
      // Trading Dashboard
      "gateway_status": "Gateway Status",
      "gateway": "Gateway",
      "authentication": "Authentication",
      "account": "Account",
      "running": "Running ✓",
      "not_running": "Not Running ✗",
      "authenticated": "Authenticated ✓",
      "not_authenticated": "Not Authenticated",
      "loading_status": "Loading status...",
      "ib_gateway_not_running": "IB Gateway Not Running",
      "orders": "Orders",
      "order_id": "Order ID",
      "side": "Side",
      "quantity": "Quantity",
      "filled": "Filled",
      "no_orders_yet": "No orders yet",
      "positions": "Positions",
      "position": "Position",
      "market_price": "Market Price",
      "market_value": "Market Value",
      "avg_cost": "Avg Cost",
      "unrealized_pnl": "Unrealized P&L",
      "no_open_positions": "No open positions",
      "cancel_order": "Cancel this order?",
      "order_cancelled": "Order cancelled successfully",
      
      // Verify Modal
      "signal_verification": "Signal Verification",
      "reason": "Reason:",
      "current_price": "Current Price",
      "entry_price": "Entry Price",
      "stop_loss": "Stop Loss",
      "take_profit": "Take Profit",
      "decided_at": "Decided At:",
      "status_updated": "Status Updated:",
      "refresh_verification": "Refresh Verification",
      
      // Setup Instructions
      "setup_instructions": "Setup Instructions",
      
      // Language Selector
      "search_languages": "Search languages...",
      "no_languages_found": "No languages found",
      
      // Misc
      "back_to_scanner": "Back to Scanner",
      "swipe_hint": "← Swipe left/right to view all columns →",
    }
  },
  es: {
    translation: {
      // Common
      "welcome": "Bienvenido",
      "admin": "Administrador",
      "system_settings": "Configuración del sistema",
      "logout": "Cerrar sesión",
      "login": "Iniciar sesión",
      "register": "Registrarse",
      "loading": "Cargando",
      "save": "Guardar",
      "cancel": "Cancelar",
      "delete": "Eliminar",
      "edit": "Editar",
      "update": "Actualizar",
      "create": "Crear",
      "search": "Buscar",
      "filter": "Filtrar",
      "clear": "Limpiar",
      "refresh": "Actualizar",
      "back": "Atrás",
      "close": "Cerrar",
      "yes": "Sí",
      "no": "No",
      "all": "Todo",
      "please_wait": "Por favor espere...",
      
      // Login Page
      "username_email": "Usuario/Correo",
      "password": "Contraseña",
      "confirm_password": "Confirmar contraseña",
      "first_name": "Nombre",
      "last_name": "Apellido",
      "phone_number": "Número de teléfono",
      "country": "País",
      "phone_number_placeholder": "Número de teléfono",
      "email_placeholder": "tu.email@ejemplo.com",
      "dont_have_account": "¿No tienes cuenta? Regístrate",
      "already_have_account": "¿Ya tienes cuenta? Inicia sesión",
      "passwords_not_match": "Las contraseñas no coinciden. Inténtalo de nuevo.",
      "registration_successful": "¡Registro exitoso! Por favor inicia sesión.",
      "pending_admin_approval": "Pendiente de aprobación del administrador",
      "you_will_be_able_to_login": "Podrás iniciar sesión una vez aprobado.",
      
      // Scanner Dashboard
      "scanner_dashboard": "Escáner de Resistencias",
      "view_toggle_label": "Selector rápido",
      "resistance_scanner_label": "Escáner de Resistencias",
      "earnings_label": "Ganancias",
      "scanner_options": "Opciones del escáner",
      "run_scanner": "Ejecutar Escáner",
      "ib_trading": "Trading IB",
      "scanner": "Escáner",
      "select_all": "Seleccionar todo",
      "clear_all": "Borrar todo",
      "saved_lists": "Listas guardadas",
      "last_updated": "Última actualización",
      "just_now": "Justo ahora",
      "found_scan_results": "Se encontraron",
      "scan_results": "resultados del escaneo",
      "no_scan_results": "No se encontraron resultados. Usa el menú izquierdo para ejecutar un escaneo o ajusta tus filtros.",
      
      // Table Headers
      "id": "ID",
      "symbol": "Símbolo",
      "put_call": "Put/Call",
      "live_price": "Precio en vivo",
      "entry": "Entrada",
      "stop": "Stop",
      "target": "Objetivo",
      "risk_reward": "R:R",
      "status": "Estado",
      "scan_date": "Fecha de escaneo",
      "actions": "Acciones",
      "signal": "Señal",
      "price": "Precio",
      
      // Scanner Menu
      "symbols": "Símbolos",
      "selected": "seleccionados",
      "period": "Período",
      "interval": "Intervalo",
      "lookback_bars": "Barras retrospectivas",
      "account_size": "Tamaño de cuenta ($)",
      "risk_per_trade": "Riesgo por operación (%)",
      "save_current": "Guardar actual",
      "scanner_options": "Opciones del escáner",
      "run_scanner": "Ejecutar Escáner",
      "running_scan": "Ejecutando escaneo...",
      "saved_lists_heading": "Tus listas guardadas:",
      "symbol_count_label": "{{count}} símbolos",
      "load_symbols_tooltip": "Cargar símbolos",
      "run_saved_list_tooltip": "Ejecutar escaneo inmediatamente",
      "delete_list_tooltip": "Eliminar lista",
      "load": "Cargar",
      "run_now": "Ejecutar",
      "symbols_found_count": "{{count}} símbolos encontrados",
      "selected_count_label": "Seleccionados ({{count}}):",
      "period_recommended_hint": "Recomendado: 5 días",
      "period_helper_text": "5 días brindan el contexto óptimo para rupturas intradía",
      "interval_recommended_hint": "Recomendado: 5 min",
      "interval_helper_text": "El intervalo de 5 minutos es el estándar para el day trading",
      "lookback_recommended_hint": "Recomendado: 100",
      "lookback_helper_text": "50-100 barras ideal para detectar rupturas recientes",
      "risk_pct_hint": "0.1-10%",
      "save_symbol_list_title": "Guardar lista de símbolos",
      "save_symbol_list_description": "Guarda tu selección actual de {{count}} símbolos para acceder rápidamente.",
      "deselect_all": "Deseleccionar todo",
      "enter_list_name_alert": "Por favor ingresa un nombre para esta lista de símbolos.",
      "save_list_success": "✅ Guardado \"{{name}}\" con {{count}} símbolos",
      "save_list_failed": "No se pudo guardar la lista de símbolos",
      "load_list_success": "✅ Cargado \"{{name}}\" ({{count}} símbolos)",
      "delete_list_success": "✅ Eliminado \"{{name}}\"",
      "delete_list_failed": "No se pudo eliminar la lista de símbolos",
      "confirm_delete_list": "¿Eliminar \"{{name}}\"?",
      "run_saved_list_initiated": "✅ Ejecutando escaneo para \"{{name}}\"...",
      "select_all_success": "Seleccionados {{count}} símbolos",
      "scan_summary_with_signals": "✅ Escaneados {{total}} símbolos. Se encontraron {{signals}} señal(es): {{summary}}",
      "scan_summary_no_signals": "✅ Escaneados {{total}} símbolos - No se encontraron señales",
      "scan_failed": "Fallo al escanear",
      "how_it_works": "Cómo funciona:",
      "search_by_symbol": "Buscar por símbolo o nombre de empresa (ej. AAPL o Apple)...",
      "no_symbols_found": "No se encontraron símbolos",
      "symbols_found": "símbolos encontrados",
      "showing_first_100": "Mostrando los primeros 100 resultados. Sigue escribiendo para reducir la búsqueda...",
      "select_symbol": "Selecciona un símbolo del S&P 500",
      "configure_params": "Configura los parámetros de escaneo",
      "click_run_scanner": "Haz clic en 'Ejecutar Escáner' para iniciar",
      "results_appear": "Los resultados aparecen en la tabla",
      "click_rows": "Haz clic en las filas para verificar señales",
      "recommended": "Recomendado",
      "save_symbol_list": "Guardar lista de símbolos",
      "enter_list_name": "Ingresa un nombre para esta lista...",
      "save_selection": "Guarda tu selección actual de",
      "symbols_quick_access": "símbolos para acceso rápido más tarde.",
      
      // Filters
      "has_signal": "Tiene señal",
      "pending": "Pendiente",
      "enter_now": "Entrar ahora",
      "target_hit": "Objetivo alcanzado",
      "stopped": "Detenido",
      "expired": "Expirado",
      "invalid": "Inválido",
      
      // Actions
      "remove": "Eliminar",
      "trade": "Operar",
      "verify": "Verificar",
      "verify_all": "Verificar todo",
      "archive_expired": "Archivar expirados",
      "refreshing": "Actualizando...",
      "are_you_sure_remove": "¿Estás seguro de que deseas eliminar este resultado del escaneo?",
      "verify_all_positions": "¿Verificar todas las {{count}} posiciones en la tabla?",
      "archive_expired_positions": "¿Archivar {{count}} posición(es) expirada(s)? Esto las ocultará de la vista activa.",
      "no_expired_found": "No se encontraron posiciones expiradas en la vista actual.",
      
      // Admin Panel
      "admin_panel": "Panel de Administración",
      "user_management": "Panel de Gestión de Usuarios",
      "create_new_user": "Crear Nuevo Usuario",
      "total_users": "Total de Usuarios",
      "pending_approval": "Pendiente de Aprobación",
      "active_users": "Usuarios Activos",
      "inactive_users": "Usuarios Inactivos",
      "admin_users": "Usuarios Administradores",
      "username": "Usuario",
      "role": "Rol",
      "created_at": "Creado el",
      "user": "Usuario",
      "approve": "Aprobar",
      "disable": "Desactivar",
      "enable": "Activar",
      "change_password": "Cambiar contraseña",
      "make_admin": "Hacer administrador",
      "remove_admin": "Quitar administrador",
      "new_password": "Nueva contraseña",
      "make_user_admin": "Hacer que este usuario sea administrador",
      "user_created_successfully": "Usuario creado exitosamente",
      "user_updated_successfully": "Usuario actualizado exitosamente",
      "user_deleted_successfully": "Usuario eliminado exitosamente",
      "are_you_sure_delete_user": "¿Estás seguro de que deseas eliminar al usuario",
      "create_user": "Crear Usuario",
      "change_password_for": "Cambiar contraseña para",
      "no_users_found": "No se encontraron usuarios",
      "active": "Activo",
      "disabled": "Desactivado",
      "pending": "Pendiente",
      
      // IB Trading
      "ib_credentials": "Credenciales",
      "trading_dashboard": "Panel de Trading",
      "interactive_brokers_setup": "Configuración de Interactive Brokers",
      "ib_credentials_configured": "Credenciales IB Configuradas",
      "ib_username": "Usuario IB",
      "ib_password": "Contraseña IB",
      "account_id": "ID de Cuenta",
      "password_encrypted": "••••••••••••• (encriptada)",
      "update_credentials": "Actualizar Credenciales",
      "delete_credentials": "Eliminar Credenciales",
      "add_ib_credentials": "Agregar Credenciales IB",
      "connect_ib_account": "Conecta tu cuenta de paper trading de Interactive Brokers para habilitar trading automatizado de opciones.",
      "ib_paper_account_id": "ID de Cuenta Paper IB",
      "default_paper_account": "Por defecto: DUN146698 (cuenta de paper trading)",
      "save_credentials": "Guardar Credenciales",
      "saving": "Guardando...",
      "security_note": "Nota de Seguridad:",
      "credentials_encrypted": "Tus credenciales se encriptan antes del almacenamiento usando encriptación estándar de la industria.",
      "ib_credentials_saved": "¡Credenciales IB guardadas exitosamente!",
      "ib_credentials_deleted": "Credenciales IB eliminadas exitosamente",
      "are_you_sure_delete_credentials": "¿Estás seguro de que deseas eliminar tus credenciales IB?",
      
      // Trading Dashboard
      "gateway_status": "Estado del Gateway",
      "gateway": "Gateway",
      "authentication": "Autenticación",
      "account": "Cuenta",
      "running": "Ejecutándose ✓",
      "not_running": "No ejecutándose ✗",
      "authenticated": "Autenticado ✓",
      "not_authenticated": "No autenticado",
      "loading_status": "Cargando estado...",
      "ib_gateway_not_running": "Gateway IB No Ejecutándose",
      "orders": "Órdenes",
      "order_id": "ID de Orden",
      "side": "Lado",
      "quantity": "Cantidad",
      "filled": "Ejecutado",
      "no_orders_yet": "Aún no hay órdenes",
      "positions": "Posiciones",
      "position": "Posición",
      "market_price": "Precio de Mercado",
      "market_value": "Valor de Mercado",
      "avg_cost": "Costo Promedio",
      "unrealized_pnl": "P&L No Realizado",
      "no_open_positions": "No hay posiciones abiertas",
      "cancel_order": "¿Cancelar esta orden?",
      "order_cancelled": "Orden cancelada exitosamente",
      
      // Verify Modal
      "signal_verification": "Verificación de Señal",
      "reason": "Razón:",
      "current_price": "Precio Actual",
      "entry_price": "Precio de Entrada",
      "stop_loss": "Stop Loss",
      "take_profit": "Take Profit",
      "decided_at": "Decidido en:",
      "status_updated": "Estado Actualizado:",
      "refresh_verification": "Actualizar Verificación",
      
      // Setup Instructions
      "setup_instructions": "Instrucciones de Configuración",
      
      // Language Selector
      "search_languages": "Buscar idiomas...",
      "no_languages_found": "No se encontraron idiomas",
      
      // Misc
      "back_to_scanner": "Volver al Escáner",
      "swipe_hint": "← Desliza izquierda/derecha para ver todas las columnas →",
    }
  },
  fr: {
    translation: {
      // Common
      "welcome": "Bienvenue",
      "admin": "Administrateur",
      "system_settings": "Paramètres du système",
      "logout": "Se déconnecter",
      "login": "Se connecter",
      "register": "S'inscrire",
      "loading": "Chargement",
      "save": "Enregistrer",
      "cancel": "Annuler",
      "delete": "Supprimer",
      "edit": "Modifier",
      "update": "Mettre à jour",
      "create": "Créer",
      "search": "Rechercher",
      "filter": "Filtrer",
      "clear": "Effacer",
      "refresh": "Actualiser",
      "back": "Retour",
      "close": "Fermer",
      "yes": "Oui",
      "no": "Non",
      "all": "Tout",
      "please_wait": "Veuillez patienter...",
      
      // Login Page
      "username_email": "Nom d'utilisateur/Email",
      "password": "Mot de passe",
      "confirm_password": "Confirmer le mot de passe",
      "first_name": "Prénom",
      "last_name": "Nom",
      "phone_number": "Numéro de téléphone",
      "country": "Pays",
      "phone_number_placeholder": "Numéro de téléphone",
      "email_placeholder": "votre.email@exemple.com",
      "dont_have_account": "Pas de compte ? Inscrivez-vous",
      "already_have_account": "Déjà un compte ? Connectez-vous",
      "passwords_not_match": "Les mots de passe ne correspondent pas. Veuillez réessayer.",
      "registration_successful": "Inscription réussie ! Veuillez vous connecter.",
      "pending_admin_approval": "En attente d'approbation de l'administrateur",
      "you_will_be_able_to_login": "Vous pourrez vous connecter une fois approuvé.",
      
      // Scanner Dashboard
      "scanner_dashboard": "Scanner de Résistances",
      "view_toggle_label": "Bascule rapide",
      "resistance_scanner_label": "Scanner de Résistances",
      "earnings_label": "Résultats",
      "scanner_options": "Options du scanner",
      "run_scanner": "Lancer le scanner",
      "ib_trading": "Trading IB",
      "scanner": "Scanner",
      "select_all": "Tout sélectionner",
      "clear_all": "Tout effacer",
      "saved_lists": "Listes sauvegardées",
      "last_updated": "Dernière mise à jour",
      "just_now": "À l'instant",
      "found_scan_results": "Trouvé",
      "scan_results": "résultats de scan",
      "no_scan_results": "Aucun résultat trouvé. Utilisez le menu de gauche pour lancer un scan ou ajustez vos filtres.",
      
      // Table Headers
      "id": "ID",
      "symbol": "Symbole",
      "put_call": "Put/Call",
      "live_price": "Prix en direct",
      "entry": "Entrée",
      "stop": "Stop",
      "target": "Objectif",
      "risk_reward": "R:R",
      "status": "Statut",
      "scan_date": "Date de scan",
      "actions": "Actions",
      "signal": "Signal",
      "price": "Prix",
      
      // Scanner Menu
      "symbols": "Symboles",
      "selected": "sélectionnés",
      "period": "Période",
      "interval": "Intervalle",
      "lookback_bars": "Barres rétrospectives",
      "account_size": "Taille du compte ($)",
      "risk_per_trade": "Risque par trade (%)",
      "save_current": "Sauvegarder actuel",
      "scanner_options": "Options du scanner",
      "run_scanner": "Lancer le scanner",
      "running_scan": "Scan en cours...",
      "saved_lists_heading": "Vos listes enregistrées :",
      "symbol_count_label": "{{count}} symboles",
      "load_symbols_tooltip": "Charger les symboles",
      "run_saved_list_tooltip": "Lancer immédiatement l'analyse",
      "delete_list_tooltip": "Supprimer la liste",
      "load": "Charger",
      "run_now": "Lancer",
      "symbols_found_count": "{{count}} symboles trouvés",
      "selected_count_label": "Sélectionnés ({{count}}) :",
      "period_recommended_hint": "Recommandé : 5 jours",
      "period_helper_text": "5 jours offrent un contexte optimal pour les cassures intraday",
      "interval_recommended_hint": "Recommandé : 5 min",
      "interval_helper_text": "L'intervalle 5 minutes est la norme pour le day trading",
      "lookback_recommended_hint": "Recommandé : 100",
      "lookback_helper_text": "50-100 barres idéales pour détecter les cassures récentes",
      "risk_pct_hint": "0,1-10 %",
      "save_symbol_list_title": "Enregistrer la liste de symboles",
      "save_symbol_list_description": "Enregistrez votre sélection actuelle de {{count}} symboles pour y accéder rapidement.",
      "deselect_all": "Tout désélectionner",
      "enter_list_name_alert": "Veuillez saisir un nom pour cette liste de symboles.",
      "save_list_success": "✅ \"{{name}}\" enregistré avec {{count}} symboles",
      "save_list_failed": "Échec de l'enregistrement de la liste de symboles",
      "load_list_success": "✅ \"{{name}}\" chargé ({{count}} symboles)",
      "delete_list_success": "✅ \"{{name}}\" supprimé",
      "delete_list_failed": "Échec de la suppression de la liste de symboles",
      "confirm_delete_list": "Supprimer \"{{name}}\" ?",
      "run_saved_list_initiated": "✅ Lancement du scan pour \"{{name}}\"...",
      "select_all_success": "{{count}} symboles sélectionnés",
      "scan_summary_with_signals": "✅ {{total}} symboles scannés ! {{signals}} signal(s) trouvé(s) : {{summary}}",
      "scan_summary_no_signals": "✅ {{total}} symboles scannés - Aucun signal trouvé",
      "scan_failed": "Échec du scan",
      "how_it_works": "Comment ça marche :",
      "search_by_symbol": "Rechercher par symbole ou nom d'entreprise (ex. AAPL ou Apple)...",
      "no_symbols_found": "Aucun symbole trouvé",
      "symbols_found": "symboles trouvés",
      "showing_first_100": "Affichage des 100 premiers résultats. Continuez à taper pour affiner la recherche...",
      "select_symbol": "Sélectionner un symbole du S&P 500",
      "configure_params": "Configurer les paramètres de scan",
      "click_run_scanner": "Cliquez sur 'Lancer le scanner' pour exécuter",
      "results_appear": "Les résultats apparaissent dans le tableau",
      "click_rows": "Cliquez sur les lignes pour vérifier les signaux",
      "recommended": "Recommandé",
      "save_symbol_list": "Sauvegarder la liste de symboles",
      "enter_list_name": "Entrez un nom pour cette liste...",
      "save_selection": "Sauvegarder votre sélection actuelle de",
      "symbols_quick_access": "symboles pour un accès rapide ultérieur.",
      
      // Filters
      "has_signal": "A un signal",
      "pending": "En attente",
      "enter_now": "Entrer maintenant",
      "target_hit": "Objectif atteint",
      "stopped": "Arrêté",
      "expired": "Expiré",
      "invalid": "Invalide",
      
      // Actions
      "remove": "Supprimer",
      "trade": "Trader",
      "verify": "Vérifier",
      "verify_all": "Tout vérifier",
      "archive_expired": "Archiver expirés",
      "refreshing": "Actualisation...",
      "are_you_sure_remove": "Êtes-vous sûr de vouloir supprimer ce résultat de scan ?",
      "verify_all_positions": "Vérifier toutes les {{count}} positions dans le tableau ?",
      "archive_expired_positions": "Archiver {{count}} position(s) expirée(s) ? Cela les masquera de la vue active.",
      "no_expired_found": "Aucune position expirée trouvée dans la vue actuelle.",
      
      // Admin Panel
      "admin_panel": "Panneau d'administration",
      "user_management": "Tableau de bord de gestion des utilisateurs",
      "create_new_user": "Créer un nouvel utilisateur",
      "total_users": "Total des utilisateurs",
      "pending_approval": "En attente d'approbation",
      "active_users": "Utilisateurs actifs",
      "inactive_users": "Utilisateurs inactifs",
      "admin_users": "Utilisateurs administrateurs",
      "username": "Nom d'utilisateur",
      "role": "Rôle",
      "created_at": "Créé le",
      "user": "Utilisateur",
      "approve": "Approuver",
      "disable": "Désactiver",
      "enable": "Activer",
      "change_password": "Changer le mot de passe",
      "make_admin": "Rendre administrateur",
      "remove_admin": "Retirer l'administrateur",
      "new_password": "Nouveau mot de passe",
      "make_user_admin": "Faire de cet utilisateur un administrateur",
      "user_created_successfully": "Utilisateur créé avec succès",
      "user_updated_successfully": "Utilisateur mis à jour avec succès",
      "user_deleted_successfully": "Utilisateur supprimé avec succès",
      "are_you_sure_delete_user": "Êtes-vous sûr de vouloir supprimer l'utilisateur",
      "create_user": "Créer un utilisateur",
      "change_password_for": "Changer le mot de passe pour",
      "no_users_found": "Aucun utilisateur trouvé",
      "active": "Actif",
      "disabled": "Désactivé",
      "pending": "En attente",
      
      // IB Trading
      "ib_credentials": "Identifiants",
      "trading_dashboard": "Tableau de bord de trading",
      "interactive_brokers_setup": "Configuration Interactive Brokers",
      "ib_credentials_configured": "Identifiants IB configurés",
      "ib_username": "Nom d'utilisateur IB",
      "ib_password": "Mot de passe IB",
      "account_id": "ID du compte",
      "password_encrypted": "••••••••••••• (crypté)",
      "update_credentials": "Mettre à jour les identifiants",
      "delete_credentials": "Supprimer les identifiants",
      "add_ib_credentials": "Ajouter les identifiants IB",
      "connect_ib_account": "Connectez votre compte de paper trading Interactive Brokers pour activer le trading automatisé d'options.",
      "ib_paper_account_id": "ID du compte Paper IB",
      "default_paper_account": "Par défaut : DUN146698 (compte de paper trading)",
      "save_credentials": "Enregistrer les identifiants",
      "saving": "Enregistrement...",
      "security_note": "Note de sécurité :",
      "credentials_encrypted": "Vos identifiants sont cryptés avant le stockage en utilisant un cryptage standard de l'industrie.",
      "ib_credentials_saved": "Identifiants IB enregistrés avec succès !",
      "ib_credentials_deleted": "Identifiants IB supprimés avec succès",
      "are_you_sure_delete_credentials": "Êtes-vous sûr de vouloir supprimer vos identifiants IB ?",
      
      // Trading Dashboard
      "gateway_status": "Statut de la passerelle",
      "gateway": "Passerelle",
      "authentication": "Authentification",
      "account": "Compte",
      "running": "En cours d'exécution ✓",
      "not_running": "Non en cours d'exécution ✗",
      "authenticated": "Authentifié ✓",
      "not_authenticated": "Non authentifié",
      "loading_status": "Chargement du statut...",
      "ib_gateway_not_running": "Passerelle IB non en cours d'exécution",
      "orders": "Ordres",
      "order_id": "ID de l'ordre",
      "side": "Côté",
      "quantity": "Quantité",
      "filled": "Exécuté",
      "no_orders_yet": "Aucun ordre pour le moment",
      "positions": "Positions",
      "position": "Position",
      "market_price": "Prix du marché",
      "market_value": "Valeur marchande",
      "avg_cost": "Coût moyen",
      "unrealized_pnl": "P&L non réalisé",
      "no_open_positions": "Aucune position ouverte",
      "cancel_order": "Annuler cet ordre ?",
      "order_cancelled": "Ordre annulé avec succès",
      
      // Verify Modal
      "signal_verification": "Vérification du signal",
      "reason": "Raison :",
      "current_price": "Prix actuel",
      "entry_price": "Prix d'entrée",
      "stop_loss": "Stop Loss",
      "take_profit": "Take Profit",
      "decided_at": "Décidé à :",
      "status_updated": "Statut mis à jour :",
      "refresh_verification": "Actualiser la vérification",
      
      // Setup Instructions
      "setup_instructions": "Instructions de configuration",
      
      // Language Selector
      "search_languages": "Rechercher des langues...",
      "no_languages_found": "Aucune langue trouvée",
      
      // Misc
      "back_to_scanner": "Retour au scanner",
      "swipe_hint": "← Balayez vers la gauche/droite pour voir toutes les colonnes →",
    }
  },
  it: {
    translation: {
      // Common
      "welcome": "Benvenuto",
      "admin": "Amministratore",
      "system_settings": "Impostazioni di sistema",
      "logout": "Esci",
      "login": "Accedi",
      "register": "Registrati",
      "loading": "Caricamento",
      "save": "Salva",
      "cancel": "Annulla",
      "delete": "Elimina",
      "edit": "Modifica",
      "update": "Aggiorna",
      "create": "Crea",
      "search": "Cerca",
      "filter": "Filtra",
      "clear": "Cancella",
      "refresh": "Aggiorna",
      "back": "Indietro",
      "close": "Chiudi",
      "yes": "Sì",
      "no": "No",
      "all": "Tutto",
      "please_wait": "Attendere prego...",
      
      // Login Page
      "username_email": "Nome utente/Email",
      "password": "Password",
      "confirm_password": "Conferma password",
      "first_name": "Nome",
      "last_name": "Cognome",
      "phone_number": "Numero di telefono",
      "country": "Paese",
      "phone_number_placeholder": "Numero di telefono",
      "email_placeholder": "tua.email@esempio.com",
      "dont_have_account": "Non hai un account? Registrati",
      "already_have_account": "Hai già un account? Accedi",
      "passwords_not_match": "Le password non corrispondono. Riprova.",
      "registration_successful": "Registrazione riuscita! Effettua l'accesso.",
      "pending_admin_approval": "In attesa di approvazione dell'amministratore",
      "you_will_be_able_to_login": "Potrai accedere una volta approvato.",
      
      // Scanner Dashboard
      "scanner_dashboard": "Dashboard Scanner",
      "view_toggle_label": "Cambio rapido",
      "resistance_scanner_label": "Scanner di Resistenze",
      "earnings_label": "Utili",
      "scanner_options": "Opzioni scanner",
      "run_scanner": "Esegui Scanner",
      "ib_trading": "Trading IB",
      "scanner": "Scanner",
      "select_all": "Seleziona tutto",
      "clear_all": "Cancella tutto",
      "saved_lists": "Liste salvate",
      "last_updated": "Ultimo aggiornamento",
      "just_now": "Proprio ora",
      "found_scan_results": "Trovati",
      "scan_results": "risultati dello scan",
      "no_scan_results": "Nessun risultato trovato. Usa il menu a sinistra per eseguire uno scan o regola i tuoi filtri.",
      
      // Table Headers
      "id": "ID",
      "symbol": "Simbolo",
      "put_call": "Put/Call",
      "live_price": "Prezzo in tempo reale",
      "entry": "Ingresso",
      "stop": "Stop",
      "target": "Obiettivo",
      "risk_reward": "R:R",
      "status": "Stato",
      "scan_date": "Data dello scan",
      "actions": "Azioni",
      "signal": "Segnale",
      "price": "Prezzo",
      
      // Scanner Menu
      "symbols": "Simboli",
      "selected": "selezionati",
      "period": "Periodo",
      "interval": "Intervallo",
      "lookback_bars": "Barre retrospettive",
      "account_size": "Dimensione dell'account ($)",
      "risk_per_trade": "Rischio per trade (%)",
      "save_current": "Salva corrente",
      "scanner_options": "Opzioni scanner",
      "run_scanner": "Esegui Scanner",
      "running_scan": "Esecuzione scan...",
      "saved_lists_heading": "Le tue liste salvate:",
      "symbol_count_label": "{{count}} simboli",
      "load_symbols_tooltip": "Carica simboli",
      "run_saved_list_tooltip": "Esegui subito la scansione",
      "delete_list_tooltip": "Elimina lista",
      "load": "Carica",
      "run_now": "Esegui",
      "symbols_found_count": "{{count}} simboli trovati",
      "selected_count_label": "Selezionati ({{count}}):",
      "period_recommended_hint": "Consigliato: 5 giorni",
      "period_helper_text": "5 giorni offrono il contesto ideale per i breakout intraday",
      "interval_recommended_hint": "Consigliato: 5 min",
      "interval_helper_text": "L'intervallo a 5 minuti è lo standard per il day trading",
      "lookback_recommended_hint": "Consigliato: 100",
      "lookback_helper_text": "50-100 barre ideali per rilevare breakout recenti",
      "risk_pct_hint": "0,1-10%",
      "save_symbol_list_title": "Salva lista simboli",
      "save_symbol_list_description": "Salva la selezione corrente di {{count}} simboli per richiamarla rapidamente.",
      "deselect_all": "Deseleziona tutto",
      "enter_list_name_alert": "Inserisci un nome per questa lista di simboli.",
      "save_list_success": "✅ Salvato \"{{name}}\" con {{count}} simboli",
      "save_list_failed": "Impossibile salvare la lista di simboli",
      "load_list_success": "✅ Caricato \"{{name}}\" ({{count}} simboli)",
      "delete_list_success": "✅ Eliminato \"{{name}}\"",
      "delete_list_failed": "Impossibile eliminare la lista di simboli",
      "confirm_delete_list": "Eliminare \"{{name}}\"?",
      "run_saved_list_initiated": "✅ Avvio scansione per \"{{name}}\"...",
      "select_all_success": "Selezionati {{count}} simboli",
      "scan_summary_with_signals": "✅ Scansionati {{total}} simboli! Trovati {{signals}} segnali: {{summary}}",
      "scan_summary_no_signals": "✅ Scansionati {{total}} simboli - Nessun segnale trovato",
      "scan_failed": "Scansione non riuscita",
      "how_it_works": "Come funziona:",
      "search_by_symbol": "Cerca per simbolo o nome dell'azienda (es. AAPL o Apple)...",
      "no_symbols_found": "Nessun simbolo trovato",
      "symbols_found": "simboli trovati",
      "showing_first_100": "Visualizzazione dei primi 100 risultati. Continua a digitare per restringere la ricerca...",
      "select_symbol": "Seleziona un simbolo dall'S&P 500",
      "configure_params": "Configura i parametri dello scan",
      "click_run_scanner": "Clicca su 'Esegui Scanner' per eseguire",
      "results_appear": "I risultati appaiono nella tabella",
      "click_rows": "Clicca sulle righe per verificare i segnali",
      "recommended": "Raccomandato",
      "save_symbol_list": "Salva lista di simboli",
      "enter_list_name": "Inserisci un nome per questa lista...",
      "save_selection": "Salva la tua selezione corrente di",
      "symbols_quick_access": "simboli per un accesso rapido in seguito.",
      
      // Filters
      "has_signal": "Ha segnale",
      "pending": "In sospeso",
      "enter_now": "Entra ora",
      "target_hit": "Obiettivo raggiunto",
      "stopped": "Fermato",
      "expired": "Scaduto",
      "invalid": "Non valido",
      
      // Actions
      "remove": "Rimuovi",
      "trade": "Scambia",
      "verify": "Verifica",
      "verify_all": "Verifica tutto",
      "archive_expired": "Archivia scaduti",
      "refreshing": "Aggiornamento...",
      "are_you_sure_remove": "Sei sicuro di voler rimuovere questo risultato dello scan?",
      "verify_all_positions": "Verificare tutte le {{count}} posizioni nella tabella?",
      "archive_expired_positions": "Archiviare {{count}} posizione/i scaduta/e? Questo le nasconderà dalla vista attiva.",
      "no_expired_found": "Nessuna posizione scaduta trovata nella vista corrente.",
      
      // Admin Panel
      "admin_panel": "Pannello di amministrazione",
      "user_management": "Dashboard di gestione utenti",
      "create_new_user": "Crea nuovo utente",
      "total_users": "Totale utenti",
      "pending_approval": "In attesa di approvazione",
      "active_users": "Utenti attivi",
      "inactive_users": "Utenti inattivi",
      "admin_users": "Utenti amministratori",
      "username": "Nome utente",
      "role": "Ruolo",
      "created_at": "Creato il",
      "user": "Utente",
      "approve": "Approva",
      "disable": "Disattiva",
      "enable": "Attiva",
      "change_password": "Cambia password",
      "make_admin": "Rendi amministratore",
      "remove_admin": "Rimuovi amministratore",
      "new_password": "Nuova password",
      "make_user_admin": "Rendi questo utente un amministratore",
      "user_created_successfully": "Utente creato con successo",
      "user_updated_successfully": "Utente aggiornato con successo",
      "user_deleted_successfully": "Utente eliminato con successo",
      "are_you_sure_delete_user": "Sei sicuro di voler eliminare l'utente",
      "create_user": "Crea utente",
      "change_password_for": "Cambia password per",
      "no_users_found": "Nessun utente trovato",
      "active": "Attivo",
      "disabled": "Disattivato",
      "pending": "In sospeso",
      
      // IB Trading
      "ib_credentials": "Credenziali",
      "trading_dashboard": "Dashboard di trading",
      "interactive_brokers_setup": "Configurazione Interactive Brokers",
      "ib_credentials_configured": "Credenziali IB configurate",
      "ib_username": "Nome utente IB",
      "ib_password": "Password IB",
      "account_id": "ID dell'account",
      "password_encrypted": "••••••••••••• (crittografata)",
      "update_credentials": "Aggiorna credenziali",
      "delete_credentials": "Elimina credenziali",
      "add_ib_credentials": "Aggiungi credenziali IB",
      "connect_ib_account": "Collega il tuo account di paper trading Interactive Brokers per abilitare il trading automatizzato di opzioni.",
      "ib_paper_account_id": "ID dell'account Paper IB",
      "default_paper_account": "Predefinito: DUN146698 (account di paper trading)",
      "save_credentials": "Salva credenziali",
      "saving": "Salvataggio...",
      "security_note": "Nota sulla sicurezza:",
      "credentials_encrypted": "Le tue credenziali vengono crittografate prima dell'archiviazione utilizzando la crittografia standard del settore.",
      "ib_credentials_saved": "Credenziali IB salvate con successo!",
      "ib_credentials_deleted": "Credenziali IB eliminate con successo",
      "are_you_sure_delete_credentials": "Sei sicuro di voler eliminare le tue credenziali IB?",
      
      // Trading Dashboard
      "gateway_status": "Stato del gateway",
      "gateway": "Gateway",
      "authentication": "Autenticazione",
      "account": "Account",
      "running": "In esecuzione ✓",
      "not_running": "Non in esecuzione ✗",
      "authenticated": "Autenticato ✓",
      "not_authenticated": "Non autenticato",
      "loading_status": "Caricamento dello stato...",
      "ib_gateway_not_running": "Gateway IB non in esecuzione",
      "orders": "Ordini",
      "order_id": "ID dell'ordine",
      "side": "Lato",
      "quantity": "Quantità",
      "filled": "Eseguito",
      "no_orders_yet": "Nessun ordine ancora",
      "positions": "Posizioni",
      "position": "Posizione",
      "market_price": "Prezzo di mercato",
      "market_value": "Valore di mercato",
      "avg_cost": "Costo medio",
      "unrealized_pnl": "P&L non realizzato",
      "no_open_positions": "Nessuna posizione aperta",
      "cancel_order": "Annullare questo ordine?",
      "order_cancelled": "Ordine annullato con successo",
      
      // Verify Modal
      "signal_verification": "Verifica del segnale",
      "reason": "Motivo:",
      "current_price": "Prezzo attuale",
      "entry_price": "Prezzo d'ingresso",
      "stop_loss": "Stop Loss",
      "take_profit": "Take Profit",
      "decided_at": "Deciso a:",
      "status_updated": "Stato aggiornato:",
      "refresh_verification": "Aggiorna verifica",
      
      // Setup Instructions
      "setup_instructions": "Istruzioni per la configurazione",
      
      // Language Selector
      "search_languages": "Cerca lingue...",
      "no_languages_found": "Nessuna lingua trovata",
      
      // Misc
      "back_to_scanner": "Torna allo Scanner",
      "swipe_hint": "← Scorri a sinistra/destra per vedere tutte le colonne →",
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    lng: localStorage.getItem('language') || 'en',
    
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    react: {
      useSuspense: false,
    }
  });

export default i18n;
